import React, { useEffect, useMemo } from 'react';
import { Modal, Button, Badge, Accordion, Alert } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useAuth } from "../../base";
import './WhatsNewModal.css';

const WhatsNewModal = ({ show, onHide, showBadge = false, handleOpenContactForm }) => {
  const { t } = useTranslation();
  const currentUser = useAuth();

  // Version-based news system - now uses translation keys
  const updates = useMemo(() => [
    {
      version: "5.9.0",
      date: "2026-10-12",
      type: "feature",
      titleKey: "whatsNew.updates.5.9.0.title",
      descriptionKey: "whatsNew.updates.5.9.0.description",
      detailsKey: "whatsNew.updates.5.9.0.details"
    },
    {
      version: "5.8.0",
      date: "2026-05-18",
      type: "feature",
      titleKey: "whatsNew.updates.5.8.0.title",
      descriptionKey: "whatsNew.updates.5.8.0.description",
      detailsKey: "whatsNew.updates.5.8.0.details"
    },
    {
      version: "5.7.0",
      date: "2026-03-29",
      type: "feature",
      titleKey: "whatsNew.updates.5.7.0.title",
      descriptionKey: "whatsNew.updates.5.7.0.description",
      detailsKey: "whatsNew.updates.5.7.0.details"
    },
    {
      version: "5.6.0",
      date: "2026-03-26",
      type: "feature",
      titleKey: "whatsNew.updates.5.6.0.title",
      descriptionKey: "whatsNew.updates.5.6.0.description",
      detailsKey: "whatsNew.updates.5.6.0.details"
    },
    {
      version: "5.5.0",
      date: "2026-03-25",
      type: "improvement",
      titleKey: "whatsNew.updates.5.5.0.title",
      descriptionKey: "whatsNew.updates.5.5.0.description",
      detailsKey: "whatsNew.updates.5.5.0.details"
    },
    {
      version: "5.4.0",
      date: "2026-03-03",
      type: "feature",
      titleKey: "whatsNew.updates.5.4.0.title",
      descriptionKey: "whatsNew.updates.5.4.0.description",
      detailsKey: "whatsNew.updates.5.4.0.details"
    },
    {
      version: "5.3.0",
      date: "2026-01-26",
      type: "feature", 
      titleKey: "whatsNew.updates.5.3.0.title",
      descriptionKey: "whatsNew.updates.5.3.0.description",
      detailsKey: "whatsNew.updates.5.3.0.details"
    },
    {
      version: "5.2.0",
      date: "2026-01-21",
      type: "improvement", 
      titleKey: "whatsNew.updates.5.2.0.title",
      descriptionKey: "whatsNew.updates.5.2.0.description",
      detailsKey: "whatsNew.updates.5.2.0.details"
    },
    {
      version: "5.1.0",
      date: "2026-01-17",
      type: "feature", 
      titleKey: "whatsNew.updates.5.1.0.title",
      descriptionKey: "whatsNew.updates.5.1.0.description",
      detailsKey: "whatsNew.updates.5.1.0.details"
    },
    {
      version: "5.0.0",
      date: "2026-01-12",
      type: "feature", 
      titleKey: "whatsNew.updates.5.0.0.title",
      descriptionKey: "whatsNew.updates.5.0.0.description",
      detailsKey: "whatsNew.updates.5.0.0.details"
    },
    {
      version: "4.8.0",
      date: "2025-12-31",
      type: "improvement", 
      titleKey: "whatsNew.updates.4.8.0.title",
      descriptionKey: "whatsNew.updates.4.8.0.description",
      detailsKey: "whatsNew.updates.4.8.0.details"
    },
    {
      version: "4.7.0",
      date: "2025-08-24",
      type: "improvement", 
      titleKey: "whatsNew.updates.4.7.0.title",
      descriptionKey: "whatsNew.updates.4.7.0.description",
      detailsKey: "whatsNew.updates.4.7.0.details"
    },
    {
      version: "4.6.0",
      date: "2025-08-15",
      type: "feature", 
      titleKey: "whatsNew.updates.4.6.0.title",
      descriptionKey: "whatsNew.updates.4.6.0.description",
      detailsKey: "whatsNew.updates.4.6.0.details"
    },
    {
      version: "4.5.0",
      date: "2025-08-23",
      type: "feature", 
      titleKey: "whatsNew.updates.4.5.0.title",
      descriptionKey: "whatsNew.updates.4.5.0.description",
      detailsKey: "whatsNew.updates.4.5.0.details"
    },
    {
      version: "4.4.0",
      date: "2025-08-23",
      type: "feature", 
      titleKey: "whatsNew.updates.4.4.0.title",
      descriptionKey: "whatsNew.updates.4.4.0.description",
      detailsKey: "whatsNew.updates.4.4.0.details"
    },
    {
      version: "4.3.0",
      date: "2025-08-23",
      type: "feature", 
      titleKey: "whatsNew.updates.4.3.0.title",
      descriptionKey: "whatsNew.updates.4.3.0.description",
      detailsKey: "whatsNew.updates.4.3.0.details"
    },
    {
      version: "4.2.1",
      date: "2025-08-23",
      type: "feature", 
      titleKey: "whatsNew.updates.4.2.1.title",
      descriptionKey: "whatsNew.updates.4.2.1.description",
      detailsKey: "whatsNew.updates.4.2.1.details"
    },
    {
      version: "4.2.0",
      date: "2025-08-20",
      type: "feature", 
      titleKey: "whatsNew.updates.4.2.0.title",
      descriptionKey: "whatsNew.updates.4.2.0.description",
      detailsKey: "whatsNew.updates.4.2.0.details"
    },
    {
      version: "4.1.5",
      date: "2025-08-15",
      type: "improvement",
      titleKey: "whatsNew.updates.4.1.5.title",
      descriptionKey: "whatsNew.updates.4.1.5.description",
      detailsKey: "whatsNew.updates.4.1.5.details"
    },
    {
      version: "4.1.4",
      date: "2025-08-10",
      type: "feature",
      titleKey: "whatsNew.updates.4.1.4.title",
      descriptionKey: "whatsNew.updates.4.1.4.description",
      detailsKey: "whatsNew.updates.4.1.4.details"
    },
    {
      version: "4.1.3",
      date: "2025-08-05",
      type: "fix",
      titleKey: "whatsNew.updates.4.1.3.title",
      descriptionKey: "whatsNew.updates.4.1.3.description",
      detailsKey: "whatsNew.updates.4.1.3.details"
    },
    {
      version: "4.1.2",
      date: "2025-08-01",
      type: "improvement",
      titleKey: "whatsNew.updates.4.1.2.title",
      descriptionKey: "whatsNew.updates.4.1.2.description",
      detailsKey: "whatsNew.updates.4.1.2.details"
    },
    {
      version: "4.1.1",
      date: "2025-07-28",
      type: "feature",
      titleKey: "whatsNew.updates.4.1.1.title",
      descriptionKey: "whatsNew.updates.4.1.1.description",
      detailsKey: "whatsNew.updates.4.1.1.details"
    },
    {
      version: "4.1.0",
      date: "2025-07-20",
      type: "warning",
      titleKey: "whatsNew.updates.4.1.0.title",
      descriptionKey: "whatsNew.updates.4.1.0.description",
      detailsKey: "whatsNew.updates.4.1.0.details"
    }
  ], []);

  const getLastSeenVersion = () => {
    try {
      return localStorage.getItem('lastSeenNewsVersion') || '0.0.0';
    } catch (e) {
      return '0.0.0';
    }
  };

  const setLastSeenVersion = (version) => {
    try {
      localStorage.setItem('lastSeenNewsVersion', version);
    } catch (e) {
      console.warn('Could not save last seen version');
    }
  };

  const compareVersions = (a, b) => {
    const parseVersion = (version) => version.split('.').map(Number);
    const versionA = parseVersion(a);
    const versionB = parseVersion(b);
    
    for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
      const numA = versionA[i] || 0;
      const numB = versionB[i] || 0;
      if (numA > numB) return 1;
      if (numA < numB) return -1;
    }
    return 0;
  };

  const hasUnreadUpdates = useMemo(() => {
    if (!currentUser) {
      return false;
    }

    const lastSeenVersion = getLastSeenVersion();
    const latestVersion = updates[0]?.version || '0.0.0';
    return compareVersions(latestVersion, lastSeenVersion) > 0;
  }, [currentUser, updates]);

  // When this modal is shown, add a body class so we can increase z-index
  // and prevent pointer events from passing through on small screens.
  useEffect(() => {
    const BODY_CLASS = 'whats-new-open';
    let scrollY = 0;

    try {
      if (show) {
        // store current scroll position
        scrollY = window.scrollY || window.pageYOffset || 0;
        // add body class for z-index rules
        document.body.classList.add(BODY_CLASS);
        // Lock scrolling by fixing body (handles mobile iOS momentum)
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
      } else {
        // remove lock and restore scroll
        document.body.classList.remove(BODY_CLASS);
        // capture stored top from body
        const top = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        if (top) {
          const restoredY = parseInt(top || '0', 10) * -1 || 0;
          window.scrollTo(0, restoredY);
        }
      }
    } catch (e) {
      // best-effort: if anything fails, ensure class removal on hide
      try { if (!show) document.body.classList.remove(BODY_CLASS); } catch (e2) {}
    }

    return () => {
      try {
        document.body.classList.remove(BODY_CLASS);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
      } catch (e) {}
    };
  }, [show]);

  const handleClose = () => {
    // Mark all current updates as seen
    if (updates.length > 0) {
      setLastSeenVersion(updates[0].version);
    }
    onHide();
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'feature': return '✨';
      case 'fix': return '🔧';
      case 'improvement': return '⚡';
      case 'warning': return '⚠️';
      default: return 'ℹ️';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'feature': return 'success';
      case 'fix': return 'warning';
      case 'improvement': return 'info';
      case 'warning': return 'danger';
      default: return 'secondary';
    }
  };

  const getNewBadge = (version) => {
    const lastSeenVersion = getLastSeenVersion();
    const isNew = compareVersions(version, lastSeenVersion) > 0;
    return isNew ? <Badge bg="danger" className="ms-2">NEW</Badge> : null;
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      size="lg"
      backdrop="static"
      keyboard={false}
      className="whats-new-modal"
    >
      <Modal.Header closeButton className="whats-new-header">
        <Modal.Title className="d-flex align-items-center">
          <span className="me-2">🎉</span>
          {t("whatsNew.title", "What's New in Façade Web App")}
          {hasUnreadUpdates && <Badge bg="danger" className="ms-2">NEW</Badge>}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="whats-new-body">
        <Alert variant="info" className="mb-4">
          <Alert.Heading className="h6">
            {t("whatsNew.welcomeTitle", "Welcome to Façade Web App Beta!")}
          </Alert.Heading>
          <p className="mb-0 small">
            {t("whatsNew.welcomeMessage", "Here are all the exciting new features and improvements we've added to make your facade design experience even better!")}
          </p>
        </Alert>

        {/* Summary of mobile-specific improvements added in this release (localized) */}
        <Alert variant="success" className="mb-4">
          <Alert.Heading className="h6">
            {t("whatsNew.mobileImprovementsTitle", "Mobile improvements")}
          </Alert.Heading>
          <p className="mb-0 small">
            {t(
              "whatsNew.mobileImprovementsBody",
              "We've shipped several mobile UX fixes: menus and dropdowns now render correctly above the canvas, menu buttons have a consistent size and shape, the Designer and zoom controls behave better on small screens (zoom is hidden by default and can be reopened), and the Try-as-Guest button is centered under the demo video for easier access. We also adjusted modal and popup handling so interactions stay responsive on mobile."
            )}
          </p>
        </Alert>

        <Accordion defaultActiveKey={hasUnreadUpdates ? "0" : undefined}>
          {updates.map((update, index) => (
            <Accordion.Item eventKey={index.toString()} key={update.version} className="mb-2">
              <Accordion.Header className="update-header">
                <div className="d-flex align-items-center justify-content-between w-100 me-3">
                  <div className="d-flex align-items-center">
                    <span className="me-2">{getTypeIcon(update.type)}</span>
                    <div>
                      <strong>{t(update.titleKey, update.titleKey)}</strong>
                      <small className="text-muted ms-2">v{update.version}</small>
                      {getNewBadge(update.version)}
                    </div>
                  </div>
                  <Badge bg={getTypeColor(update.type)} className="text-capitalize">
                    {update.type}
                  </Badge>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="update-content">
                  <p className="update-description">{t(update.descriptionKey, update.descriptionKey)}</p>
                  <ul className="update-details">
                    {t(update.detailsKey, { returnObjects: true, defaultValue: [] }).map((detail, detailIndex) => (
                      <li key={detailIndex}>{detail}</li>
                    ))}
                  </ul>
                  <small className="text-muted">{t("whatsNew.released", "Released:")} {new Date(update.date).toLocaleDateString()}</small>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>

        <Alert variant="light" className="mt-4 text-center">
          <small className="text-muted">
            {t("whatsNew.feedbackMessage.text", "Have feedback or suggestions? We'd love to hear from you!")}{" "}
            <button
              style={{
                background: 'none',
                border: 'none',
                color: '#007bff',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit'
              }}
              onClick={() => {
                if (handleOpenContactForm) {
                  handleOpenContactForm();
                  onHide(); // Close the modal
                }
              }}
            >
              {t("whatsNew.feedbackMessage.contactUs", "Contact us here")}
            </button>
          </small>
        </Alert>
      </Modal.Body>
      
      <Modal.Footer className="whats-new-footer">
        <Button variant="outline-secondary" onClick={handleClose}>
          {t("whatsNew.markAsRead", "Mark as Read")}
        </Button>
        <Button variant="primary" onClick={handleClose}>
          {t("common.close", "Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WhatsNewModal;
